export const CITY_LIST_REQUEST = 'CITY_LIST_REQUEST';
export const CITY_LIST_REQUEST_SUCCESS = 'CITY_LIST_REQUEST_SUCCESS';
export const CITY_LIST_REQUEST_ERROR = 'CITY_LIST_REQUEST_ERROR';

export const HOUSE_TYPE_LIST_REQUEST = 'HOUSE_TYPE_LIST_REQUEST';
export const HOUSE_TYPE_LIST_REQUEST_SUCCESS = 'HOUSE_TYPE_LIST_REQUEST_SUCCESS';
export const HOUSE_TYPE_LIST_REQUEST_ERROR = 'HOUSE_TYPE_LIST_REQUEST_ERROR';

export const DEGREE_LIST_REQUEST = 'DEGREE_LIST_REQUEST';
export const DEGREE_LIST_REQUEST_SUCCESS = 'DEGREE_LIST_REQUEST_SUCCESS';
export const DEGREE_LIST_REQUEST_ERROR = 'DEGREE_LIST_REQUEST_ERROR';

export const JOB_TYPE_LIST_REQUEST = 'JOB_TYPE_LIST_REQUEST';
export const JOB_TYPE_LIST_REQUEST_SUCCESS = 'JOB_TYPE_LIST_REQUEST_SUCCESS';
export const JOB_TYPE_LIST_REQUEST_ERROR = 'JOB_TYPE_LIST_REQUEST_ERROR';

export const JOB_POSITION_TYPE_LIST_REQUEST = 'JOB_POSITION_TYPE_LIST_REQUEST';
export const JOB_POSITION_TYPE_LIST_REQUEST_SUCCESS = 'JOB_POSITION_TYPE_LIST_REQUEST_SUCCESS';
export const JOB_POSITION_TYPE_LIST_REQUEST_ERROR = 'JOB_POSITION_TYPE_LIST_REQUEST_ERROR';

export const BANK_LIST_REQUEST = 'BANK_LIST_REQUEST';
export const BANK_LIST_REQUEST_SUCCESS = 'BANK_LIST_REQUEST_SUCCESS';
export const BANK_LIST_REQUEST_ERROR = 'BANK_LIST_REQUEST_ERROR';

export const RELATIONSHIP_TYPE_LIST_REQUEST = 'RELATIONSHIP_TYPE_LIST_REQUEST';
export const RELATIONSHIP_TYPE_LIST_REQUEST_SUCCESS = 'RELATIONSHIP_TYPE_LIST_REQUEST_SUCCESS';
export const RELATIONSHIP_TYPE_LIST_REQUEST_ERROR = 'RELATIONSHIP_TYPE_LIST_REQUEST_ERROR';
